"use strict";
import {mobileOrder} from './mobile/order';
import {pcOrder} from './pc/order';
import {mobileOrderSvr} from './mobile/ordersvr';
import {pcOrderSvr} from './pc/ordersvr'
import Cookies from 'js-cookie'

const buy = {
    //支付
    pay: (jData, option) => {
        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
            let order = mobileOrder();
            var pay_param = {
                appid: jData._app_id,
                _v: "v3",
                biz: jData.biz, //业务id
                plug_id: "72002", //插件id，比如7200（活动营销）、8300（积分+点券）
                iActionId: jData.iActionId, //活动号
                jifen_dikou: jData.jifen_dikou, //是否积分抵扣
            };
            order.init(pay_param);
            order.pay({
                eventid: jData.event_id, //事件id
                biz: jData.biz, //业务id
                serial: jData.serial, //订单号
                amount: jData.act_amount, //价格
                propid: jData.propid, //道具id
                onSuccess: option.onPaySuccess,
                onClose: option.onPayClose,
            });
        }else{
            let order = pcOrder();
            var pay_param = {
                appid: jData._app_id,
                _v: "v3",
                biz: jData.biz,
                plug_id: "72002",
                iActionId: jData.iActionId,
                jifen_dikou: jData.jifen_dikou,
            };
            order.init(pay_param);
            order.pay({
                _act_id: jData.iActionId,
                eventid: jData.event_id,
                _biz_code: jData.biz,
                serial: jData.serial,
                amount: jData.act_amount,
                propid: jData.propid,
                skin_black: jData.skin_black == 1 ? 1 : 0,
                onSuccess: option.onPaySuccess,
                onClose: option.onPayClose,
            });
        }
    },
    //针对使用svr下单接口使用svrpay方法
    svrpay: (jData, option) => {
        if(jData.iPayType && jData.iPayType !=2) {
            if (typeof (option.onPaySuccess) == "function") {
                option.onPaySuccess();
            } else {
                alert(jData.msg);
            }
        }
        if(!jData.urlParams && !jData.iap_payItem){
            if (jData.iPayType == 2) {
                alert('恭喜你购买成功！');
                if(typeof(option.onPaySuccess) == "function")
                {
                    option.onPaySuccess();
                }
                return false;
            }
        }
        if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
            let order = mobileOrderSvr();
            var pay_param = {
                appid: jData._app_id,
                _v: "v3",
                biz: jData.biz, //业务id
                plug_id: "72002", //插件id，比如7200（活动营销）、8300（积分+点券）
                iActionId: jData.iActionId, //活动号
                jifen_dikou: jData.jifen_dikou, //是否积分抵扣
                midas_sendbox:jData.midas_sandbox, //是否使用沙箱
                pf:jData.pf,
                urlParams:jData.urlParams,
                dc:jData.dc
            };
            order.init(pay_param);
            if(jData.ret == 0) {
                if (jData.iap_payItem != undefined) {
                    //ios支付
                    if (typeof HostApp != "undefined" || milo.cookie.get("djc_appVersion") != null && milo.cookie.get("djc_appVersion") >= 62) {
                        var param = {
                            'act_amount': jData.act_amount,
                            'act_price': jData.act_amount,
                            'app_meta': jData.app_meta,
                            'sSerialNum': jData.serial,
                            'serial': jData.serial,
                            'offerId': jData.offerId,
                            'session_id': Cookies.get('acctype') == 'wx' ? 'hy_gameid' : (Cookies.get('acctype') == 'qc' ? "openid" : 'uin'), //todo 更换获取cookie的方法
                            'session_type': Cookies.get('acctype') == 'wx' ? 'wc_actoken' : (Cookies.get('acctype') == 'qc' ? "kp_accesstoken" : 'skey'),//todo 更换获取cookie的方法
                            'pf': jData.pf,
                            'pfKey': 'pfKey',
                            'product_id': jData.product_id,
                            'iap_payItem': jData.iap_payItem,
                            'depositGameCoin': 0,
                            'zoneid': '1',
                            'productType': 0
                            //'env':0
                        };
                        HostApp.setJsCallBack('doNativeIAPPay', param, function (rsp) {
                            if(rsp.code == "0"){
                                option.onPaySuccess()
                            }else if(rsp.code == "1"){
                                // alert("已取消支付。");
                                option.onPayClose()
                            }else{
                                alert(rsp.msg);
                            }
                        });
                    }else {
                        alert('请在最新版掌上道聚城内参与活动。');
                    }
                }else {
                    //安卓支付
                    console.log("android buy")
                    console.log(jData)
                    order.pay({
                        eventid: jData.event_id,//事件id
                        biz: jData.biz,//业务id
                        serial: jData.serial,//订单号
                        amount: jData.act_amount,//价格
                        propid: jData.propid,//道具id
                        onSuccess: option.onPaySuccess,
                        onClose: option.onPayClose,
                        pf: jData.pf,
                        urlParams: jData.urlParams,
                        dc: jData.dc,
                        sandbox: jData.midas_sandbox,
                        sessionid:jData.sessionid,
                        sessiontype:jData.sessiontype,
                        openid:jData.openid,
                        openkey:jData.openkey
                    });
                }
            }else{
                if(jData.ret == -9905) {
                    alert("抱歉，您的访问频率过快，请稍后再试~")
                }else {
                    alert(jData.msg)
                }
            }
        }else {
            let order = pcOrderSvr();

            var pay_param = $.extend({}, {
                appid: jData._app_id,
                _v: "v3",
                biz: jData.biz,
                plug_id: "72002",
                iActionId: jData.iActionId,
                jifen_dikou: jData.jifen_dikou,
            });
            order.init(pay_param);
            if (jData.ret == 0) {
                order.pay({
                    _act_id: jData.iActionId,
                    eventid: jData.event_id,
                    _biz_code: jData.biz,
                    serial: jData.serial,
                    amount: jData.act_amount,
                    propid: jData.propid,
                    skin_black:option.skin_black==1?1:0,
                    onSuccess:option.onPaySuccess,
                    onClose:option.onPayClose,
                    offerId:jData.offerId,
                    sessionId:jData.sessionid,
                    sessionType:jData.sessiontype,
                    urlParams: jData.urlParams,
                    sandbox:jData.midas_sandbox,
                    pf:jData.pf,
                    dc:jData.dc,
                    openid:jData.openid,
                    openkey:jData.openkey
                });
            }else {
                if(jData.ret == -9905) {
                    alert("抱歉，您的访问频率过快，请稍后再试~")
                }else {
                    alert(jData.msg)
                }
            }
        }
    }
};


export default buy;
